const UPDATE_DICOM = 'UPDATE_DICOM';
export default UPDATE_DICOM;
